import styled from '@emotion/styled';
import { colors, fontSizes, fontWeights, gutterSizes, boxSizes } from '../base/theme';

export const SwitchWithInfoContainer = styled.div`
    border: ${boxSizes.borderWidth} solid ${colors.newBorder};
    border-radius: ${boxSizes.borderRadius8};
    padding: ${gutterSizes.base} ${gutterSizes.large} ${gutterSizes.large} ${gutterSizes.large};
    display: flex;
    flex-direction: column;
`;

export const ContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${gutterSizes.base} 0;
`;

export const Label = styled.span`
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.normal};
    color: ${colors.messageTextColor};
    flex: 1;
`;

export const InfoText = styled.p`
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.normal};
    color: ${colors.newDarkGrey};
    line-height: ${fontSizes.xlarge};
    margin: 0;
`;
